module.exports = __webpack_public_path__ + "static/media/failed.8faa518c.png";